<template>
  <div>

    <div>
       <!-- Use the component in the right place of the template -->
      <label v-if="label" class="v-label theme--light">{{ label }}</label>
      <tiptap-vuetify
          v-model="content"
          :extensions="extensions"
      />
    </div>
  </div>
</template>

<script>
// import the component and the necessary extensions

import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Underline,
  BulletList,
  ListItem,
  Link,
  HardBreak,
  History
} from 'tiptap-vuetify';

export default {
  // specify TiptapVuetify component in "components"
  components: {TiptapVuetify},
  props: {
    value: {
      type: String,
      default: ""
    },
    label: {
      type: String
    },
  },
  watch: {
    content: function(newContent) {
      this.$emit('input', newContent)
    }
  },
  data: function () {
    // declare extensions you want to use
    return {
      extensions: [
        History,
        Link,
        Underline,
        Italic,
        ListItem,
        BulletList,
        [Heading, {
          options: {
            levels: [1, 2, 3]
          }
        }],
        Bold,
        HardBreak
      ],
      // starting editor's content
      content: this.value ? this.value : ""
    }
  }
}
</script>
